import IDValidator from 'id-validator'
import { sexMapEnglish } from 'json/lab-order'
import { formatDate } from 'utils/formUtils'
let vm = new IDValidator()

export default vm

// 解析身份证，获取性别，生日等信息
export let getInfo = function (...args) {
  let info = vm.getInfo.apply(vm, args)
  if (info) {
    console.log('info', info)
    let births = info.birth.split('-')
    births[1] -= 1
    let birthday = new Date(...births).getTime()
    info = {
      ...info,
      gender: sexMapEnglish[info.sex],
      birthday,
      birthDayText: formatDate(birthday)
    }
    return info
  } else {
    this.$message.error('身份证号码不正确，请检查', { mask: false, time: 1500 })
    return {}
  }
}
